import { useDatadog } from '@/composables/datadog'
import { useAuth } from '@simplifi/auth'
import { updateGlobalContext } from '@simplifi/logging'
import type { RouteLocationNormalized, Router } from 'vue-router'

export function registerGuard(router: Router) {
  router.beforeEach(async (to: RouteLocationNormalized) => {
    if (to.meta.requiresAuth) {
      if (!(await useAuth().signIn())) {
        return { name: 'signinError' }
      }
    }

    if (useAuth().loggedIn && !useDatadog().isContextSet.value) {
      const token = await useAuth().getToken()
      if (token) {
        updateGlobalContext(token)
        useDatadog().isContextSet.value = true
      }
    }

    return true
  })
}
